/**
 * 契約番号(M番号)のバリデーション.
 * 先頭は半角大文字「M」で、以降は半角数字8桁で入力されること */

export default {
  validate(value: string | undefined | null): boolean {
    if (!value) return true;

    const pattern = /^M[0-9]{8}$/;

    return pattern.test(value);
  },
};
